import { graphql } from "../generated/gql";

export const SavePlaybookResult = graphql(
  `
    mutation SavePlaybookResult($input: SavePlaybookResultInput!) {
      savePlaybookResult(input: $input) {
        __typename
        ... on PlaybookResult {
          ...PlaybookResult
        }
        ... on GenericException {
          ...BaseException
        }
        ... on PlaybookException {
          ...BaseException
        }
        ... on UserInputException {
          ...UserInputException
        }
        ... on InsufficientLicenseException {
          ...InsufficientLicenseException
        }
      }
    }
  `
);
